import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./auth/Login";
import ForgetPassword from "./auth/ForgetPassword";
import Dashboard from "./pages/Dashboard/Dashboard";
import Users from "./pages/Client/ClientManagement";
import Employee from "./pages/Employee/Employee";
import Blogs from "./pages/Blogs/Blogs";
import ProtectedRoute from "./components/ProtectedRoute";
import DocumentsPage from "./pages/Client/DocumentsPage";
import AdminPaymentManagement from './pages/PaymentManagement/AdminPaymentManagement';
import QuestionManagement from './pages/QuestionManagement/QuestionManagement';
import ReferralManagement from './pages/ReferralManagement/ReferralManagement';
import MeetingManagement from './pages/Meetings/MeetingManagement';
import ContactsHub from "./pages/ContactManagement/ContactsHub";
import WebinarManagement from "./pages/WebinarManagement/WebinarManagement";
import PromoCodeManagement from "./pages/PromoCodeManagement/PromoCodeManagement";
import RecycleBin from "./pages/RecycleBin/RecycleBin";
import LoginHistory from "./pages/LoginHistory/LoginHistory";
import Analytics from "./pages/Analytics/Analytics";
import EventsManagement from "./pages/EmailCampaigns/EventsManagement";
import EmailTemplates from "./pages/EmailCampaigns/EmailTemplates";
import CampaignScheduler from "./pages/EmailCampaigns/CampaignScheduler";
import CampaignLogs from "./pages/EmailCampaigns/CampaignLogs";
import LeadManagement from "./pages/LeadManagement/LeadManagement";
import WhyBooksComplyCMS from "./pages/WebsiteCMS/WhyBooksComplyCMS";
import HelpCenterCMS from "./pages/WebsiteCMS/HelpCenterCMS";
import LegalPagesCMS from "./pages/WebsiteCMS/LegalPagesCMS";
import ZohoEventCMS from "./pages/WebsiteCMS/ZohoEventCMS";
import IndustryPagesCMS from "./pages/WebsiteCMS/IndustryPagesCMS";
import NavigationCMS from "./pages/WebsiteCMS/NavigationCMS";
import PricingCMS from "./pages/WebsiteCMS/PricingCMS";
import BlogPageCMS from "./pages/WebsiteCMS/BlogPageCMS";
import USACompanyFormationCMS from "./pages/WebsiteCMS/USACompanyFormationCMS";
import TaxReturnCMS from "./pages/WebsiteCMS/TaxReturnCMS";
import BookkeepingCMS from "./pages/WebsiteCMS/BookkeepingCMS";
import CFOAdvisoryCMS from "./pages/WebsiteCMS/CFOAdvisoryCMS";
import ZohoAdvisoryCMS from "./pages/WebsiteCMS/ZohoAdvisoryCMS";
import HomeCMS from "./pages/WebsiteCMS/HomeCMS";
import AllPagesCMS from "./pages/WebsiteCMS/AllPagesCMS";




function App() {
  return (
    <Router>
      <Routes>
        {/* Header and sidebar are not shown */}
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgetpassword" element={<ForgetPassword />} />

        {/* Apply layout only for the routes that need header and side navbar */}
        <Route path="/" element={<Layout />}>
          <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
          <Route path="/blogs" element={<ProtectedRoute> <Blogs /> </ProtectedRoute>} />
          <Route path="/client" element={<ProtectedRoute> <Users /> </ProtectedRoute>} />
          <Route path="/employee" element={<ProtectedRoute> <Employee /> </ProtectedRoute>} />
          <Route path="/client/:userId/documents" element={<ProtectedRoute> <DocumentsPage /> </ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><AdminPaymentManagement /></ProtectedRoute>} />
          <Route path="/questions" element={<ProtectedRoute><QuestionManagement /></ProtectedRoute>} />
          <Route path="/referrals" element={<ProtectedRoute><ReferralManagement /></ProtectedRoute>} />
          <Route path="/meetings" element={<ProtectedRoute><MeetingManagement /></ProtectedRoute>} />
          <Route path="/contacts" element={<ProtectedRoute><ContactsHub /></ProtectedRoute>} />
          <Route path="/webinar-forms" element={<ProtectedRoute><WebinarManagement /></ProtectedRoute>} />
          <Route path="/promocodes" element={<ProtectedRoute><PromoCodeManagement /></ProtectedRoute>} />
          <Route path="/recycle-bin" element={<ProtectedRoute><RecycleBin /></ProtectedRoute>} />
          <Route path="/login-history" element={<ProtectedRoute><LoginHistory /></ProtectedRoute>} />
          <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
          <Route path="/email-campaigns/events" element={<ProtectedRoute><EventsManagement /></ProtectedRoute>} />
          <Route path="/email-campaigns/templates" element={<ProtectedRoute><EmailTemplates /></ProtectedRoute>} />
          <Route path="/email-campaigns/scheduler" element={<ProtectedRoute><CampaignScheduler /></ProtectedRoute>} />
          <Route path="/email-campaigns/logs" element={<ProtectedRoute><CampaignLogs /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute> <LeadManagement /> </ProtectedRoute>} />
          <Route path="/cms/pages" element={<ProtectedRoute><AllPagesCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/why-bookscomply" element={<ProtectedRoute><WhyBooksComplyCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/help-center" element={<ProtectedRoute><HelpCenterCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/legal-pages" element={<ProtectedRoute><LegalPagesCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/zoho-event" element={<ProtectedRoute><ZohoEventCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/industry-pages" element={<ProtectedRoute><IndustryPagesCMS /></ProtectedRoute>} />
          <Route path="/cms/navigation-settings" element={<ProtectedRoute><NavigationCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/pricing" element={<ProtectedRoute><PricingCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/blog-page" element={<ProtectedRoute><BlogPageCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/usa-company-formation" element={<ProtectedRoute><USACompanyFormationCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/tax-return" element={<ProtectedRoute><TaxReturnCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/bookkeeping" element={<ProtectedRoute><BookkeepingCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/cfo-advisory" element={<ProtectedRoute><CFOAdvisoryCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/zoho-advisory" element={<ProtectedRoute><ZohoAdvisoryCMS /></ProtectedRoute>} />
          <Route path="/cms/pages/home" element={<ProtectedRoute><HomeCMS /></ProtectedRoute>} />
          <Route path="/cms" element={<Navigate to="/cms/pages" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}


export default App;
